import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import '../styles/pageError.scss';

class PageError extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  render() {
    // const { t } = this.props;

    return (
      <div className="page-error">
        <div className="page-error-container">
          <h1>Internal Server Error</h1>
          <h2>Sorry, something went wrong :(</h2>
        </div>
      </div>
    );
  }
}

export default withTranslation()(PageError);
